
require([ ], function() {document.querySelectorAll("[data-scc-issue]").forEach(function(a){console.log(a.dataset.sccIssue)})}); 
define("modules/issue-console", function(){});
